// extracted by mini-css-extract-plugin
module.exports = {"description":"packageDescription_description__O01FC"};